import { getChainName } from '@ui/constants/chain';
import { ChainId, ChainName } from '@ui/types/chain';

import { GetPairsBlockChainEnum } from './generated';

/**
 * keep this before backend unify chain enum type
 */
enum ServerChainName {
  MONAD = GetPairsBlockChainEnum.Monad,
}

export function toServerBlockChain<ServerEnum>(chainId: ChainId) {
  switch (getChainName(chainId)) {
    case ChainName.MONAD:
      return ServerChainName.MONAD as ServerEnum;
    default:
      return ServerChainName.MONAD as ServerEnum;
  }
}

export enum TradingCompetitionRuleId {
  TOP_WIN_PNL = 'TOP_WIN_PNL',
  TOP_WIN_AND_LOSS_PNL = 'TOP_WIN_AND_LOSS_PNL',
  TOP_TRADING_VOLUME = 'TOP_TRADING_VOLUME',
  TOP_LOW_LEVERAGE_TRADING_VOLUME = 'TOP_LOW_LEVERAGE_TRADING_VOLUME',
  TOP_HIGH_LEVERAGE_TRADING_VOLUME = 'TOP_HIGH_LEVERAGE_TRADING_VOLUME',
}